/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React, { useState } from "react";

import { Box, Button, CircularProgress, Stack, TextField, Tooltip, Typography } from "@mui/material";

import { clearArchiveResults, selectArchiveQuery, selectArchiveResults } from "./archiveSlice";
import { ArchiveResult } from "../../utils/Interfaces";
import { listArchiveHandler } from "./archiveFunctions";
import { ArchiveCard } from "./ArchiveCard";
import StyledBreadcrumbs from "../../components/general/StyledBreadcrumbs";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

const Archive = () => {
    const globalQuery: string = useAppSelector(selectArchiveQuery);
    const results: ArchiveResult[] = useAppSelector(selectArchiveResults);

    const dispatch: Dispatch<AnyAction> = useAppDispatch();

    const [localQuery, setLocalQuery] = useState<string>("");
    const [loading, setLoading] = useState(false);

    return (
        <Box>
            <StyledBreadcrumbs
                paths={[
                    { text: "Techwise Portal", route: "/" },
                    { text: "Service", route: "/?section=office" },
                    { text: "Work Order Archive", route: "/archive" },
                ]}
            />

            <TextField
                margin="normal"
                required
                fullWidth
                name="ticket_no"
                label="Search Archive"
                type="ticket_no"
                id="ticket_no"
                value={localQuery}
                onChange={(e) => setLocalQuery(e.target.value)}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        listArchiveHandler(localQuery, dispatch, setLoading);
                    }
                }}
            />

            <Tooltip title="Search Archive">
                <Button
                    sx={{
                        marginRight: "10px",
                    }}
                    variant="contained"
                    onClick={() => listArchiveHandler(localQuery, dispatch, setLoading)}
                >
                    Search Archive
                </Button>
            </Tooltip>

            <Tooltip title={"Clear Search Results"}>
                <Button
                    sx={{ m: 3 }}
                    variant="contained"
                    onClick={() => {
                        dispatch(clearArchiveResults());
                    }}
                >
                    Clear Results
                </Button>
            </Tooltip>

            {loading && (
                <Stack direction="row" justifyContent="center" width="100%" marginTop={20}>
                    <Stack direction="column" justifyContent="center">
                        <CircularProgress size={100} />
                    </Stack>
                </Stack>
            )}

            {!loading && (
                <Box>
                    {globalQuery !== "" && (
                        <Typography variant="h6" align="center" marginBottom={2}>
                            {`Showing results for "${globalQuery}".`}
                        </Typography>
                    )}
                    {results.map((archiveResult: ArchiveResult) => {
                        return (
                            <>
                                <ArchiveCard key={`${archiveResult.id}`} archiveResult={archiveResult} />
                                <Box sx={{ marginBottom: "10px" }}></Box>
                            </>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
};

export default Archive;
